var ModulesCollectionService = function() {
  this.getModuleCollectionResponseData = function(response){
    return response.data ? [response.data] : [];
  };

  this.getModuleCollectionModuleStatusByKey = function(modStatuses, key){
    if(modStatuses[0] && modStatuses[0].attributes.data.modules){
      return modStatuses[0].attributes.data.modules[key];
    } else if (modStatuses[0] && modStatuses[0].attributes.data.module_key === key){
      return modStatuses[0].attributes.data;
    }
  };

  this.getModuleCollectionUrl = function(){
    return EF.url(`/progress/${EF.enrollment.get('id')}?filter[content_id]=${EF.enrollment.get('contentId')}`);
  };
};

module.exports = new ModulesCollectionService();